import React from 'react';

import { Splitview, Split } from '../../Split';
import { SLIDER_TICKS } from '../../../constants';

import { StatementCounter, Statement } from '../../Slider/styles';
import SliderTicks, { SliderContent, BigDifference } from './styles';

type SliderExplenationProps = {
  explenation: String,
  bigDifference: String,
  title: String,
  dependData: Object,
  id: Number,
};

/* const DIFFERENCES = {
  0: 'Jullie zijn het eens over deze stelling',
  1: 'Jullie meningen verschillen een klein beetje',
  2: 'Jullie meningen verschillen, maar begrijpen elkaar',
  3: 'Jullie meningen zijn verschillend',
  4: 'Jullie mening zit ver uit elkaar',
}; */

const Slider = ({
  explenation, bigDifference, title, dependData, id,
}: SliderExplenationProps) => {
  const personalValue = +dependData[0] || 0;
  const partnerValue = +dependData[1] || 0;
  const difference = Math.abs(personalValue - partnerValue);

  return (
    <Splitview>
      <Split width={30} left border>
        {id && (
          <StatementCounter color="partgreen">
            Stelling
            {' '}
            {id}
            /8
          </StatementCounter>
        )}
        <Statement>{title}</Statement>
      </Split>
      <Split width={70}>
        <SliderTicks>
          <div className="slider-tick-line">
            <div className="slider-tick-line-title">Mijn persoonlijke mening:</div>
            <div className="slider-tick-line-value">
              {SLIDER_TICKS.find(({ tickValue }) => +tickValue === +personalValue).tickLabel}
            </div>
          </div>
          <div className="slider-tick-line">
            <div className="slider-tick-line-title">De mening van mijn partner:</div>
            <div className="slider-tick-line-value">
              {SLIDER_TICKS.find(({ tickValue }) => +tickValue === +partnerValue).tickLabel}
            </div>
          </div>
        </SliderTicks>
        <SliderContent>
          <div dangerouslySetInnerHTML={{ __html: explenation }} />

          {difference > 1 && (
            <BigDifference color="partlightgreen">
              <strong>Jullie lijken hier allebei anders over te denken.</strong>
              <br />
              {bigDifference}
            </BigDifference>
          )}
        </SliderContent>
      </Split>
    </Splitview>
  );
};

export default Slider;
